// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input[data-v-ad5ee6f6] .v-label{margin:0}.v-input[data-v-ad5ee6f6] .v-input--selection-controls__input{-ms-flex-item-align:start;align-self:flex-start}", ""]);
// Exports
module.exports = exports;
